import { Controller } from '@hotwired/stimulus';
import { Calendar } from 'vanilla-calendar-pro';
import Axios from '../axios';

function formatDate(date) {
    return date.toLocaleDateString("lt-LT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

export default class extends Controller {
    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.postType = this.element.dataset.type ? this.element.dataset.type : 'event';

        // Config https://vanilla-calendar.pro/docs/
        this.calendar = new Calendar(this.element, {
            locale: this.currentLanguageCode,
            selectedTheme: 'light',
            onClickArrow(vc) {
                const fromDate = new Date(vc.context.selectedYear, vc.context.selectedMonth, 1);
                const toDate = new Date(vc.context.selectedYear, vc.context.selectedMonth, 0);
                toDate.setMonth(fromDate.getMonth() + 1);
                fromDate.setMonth(fromDate.getMonth() - 1);
                // this.addPopups(
                //     formatDate(fromDate),
                //     formatDate(toDate),
                // );
            },
            popups: {},
        });

        this.calendar.init();

        const fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 1);
        fromDate.setDate(1);

        const toDate = new Date();
        toDate.setMonth(toDate.getMonth() + 1);
        toDate.setDate(0);

        this.addPopups(formatDate(fromDate), formatDate(toDate));
    }

    addPopups(dateFrom, dateTo) {
        this.getInfo(dateFrom, dateTo).then(response => {
            if (response && response.data) {
                const data = response.data;
                const popups = {};
                for (const id in data) {
                    if (popups[data[id].date]) {
                        let html = popups[data[id].date].html;
                        html += `<a href="${data[id].url}">${data[id].title}</a>`;
                        popups[data[id].date].html = html;
                    } else {
                        popups[data[id].date] = {
                            modifier: 'has-events',
                            html: `<a href="${data[id].url}">${data[id].title}</a>`,
                        };
                    }
                }
                this.calendar.popups = popups;
                this.calendar.update();
            }
        });
    }

    async getInfo(dateFrom, dateTo) {
        let response = null;
        try {
            response = await Axios.post(`/wp-json/api/events-list`, {
                date_from: dateFrom,
                date_to: dateTo,
                type: this.postType,
                lang: this.currentLanguageCode,
            });
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }
        return response;
    }
}
